class Support {
    constructor(element) {
        this.el = element;
        this.slider = this.el.querySelector(".donation-slider");
        this.customDonationInputControl = this.el.querySelector(
            "[data-custom-donation-input-control]",
        );
        this.customDonationInput = this.el.querySelector(
            "[data-custom-donation-input]",
        );
        this.donateButtonAmount = this.el.querySelector(
            "[data-display-donation-amount]",
        );

        this.init();
    }

    init() {
        this.setupControls();
    }

    setupControls() {
        this.slider.addEventListener("input", (event) => {
            this.updateCustomDonationInput(event.target.value);
        });

        this.customDonationInputControl.addEventListener("input", () => {
            this.updateCustomDonationInput(
                this.customDonationInputControl.value,
            );
        });
    }

    updateCustomDonationInput(value) {
        this.customDonationInput.value = value;

        this.customDonationInput.dispatchEvent(
            new Event("input", { bubbles: true }),
        );
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const supportBlocks = document.querySelectorAll(".support--block");

    supportBlocks.forEach((element) => {
        new Support(element);
    });
});
